/**
 * Hindi for the `booking` namespace (BP-19.T2).
 *
 * **Machine draft, not reviewed** (BP-19 §14). This is the namespace the client
 * journey of BP-04 §6 renders end to end, so it is translated in full: a half-Hindi
 * booking flow reads worse than an English one. `{{…}}` placeholders are i18next's.
 */

export const bookingStringsHi = {
  landing: {
    title: 'अपॉइंटमेंट बुक करें',
    lead: 'अपनी सेवाएँ चुनिए, समय तय कीजिए — कुर्सी आपके लिए रख दी जाएगी।',
    start: 'अभी बुक करें',
    mine: 'मेरी बुकिंग',
  },
  steps: {
    services: 'सेवाएँ',
    technician: 'टेक्नीशियन',
    slot: 'समय',
    verify: 'आपका नंबर',
    confirm: 'पुष्टि',
  },
  services: {
    title: 'आप क्या कराना चाहेंगे?',
    none: 'अभी ऑनलाइन कोई सेवा बुक नहीं हो सकती',
    addons: 'अतिरिक्त',
    duration: '{{minutes}} मिनट',
    running: '{{minutes}} मिनट · ₹{{amount}}',
    next: 'टेक्नीशियन चुनें',
    pickOne: 'कम से कम एक सेवा चुनें',
  },
  technician: {
    title: 'किससे कराना चाहेंगे?',
    any: 'जो भी उपलब्ध हो',
    anyHint: 'सबसे पहले खाली होने वाली कुर्सी',
    next: 'समय चुनें',
    none: 'अभी कोई भी ऑनलाइन बुकिंग नहीं ले रहा',
  },
  slot: {
    title: 'कौन-सा समय ठीक रहेगा?',
    none: 'उस दिन कुछ खाली नहीं है',
    suggestion: 'अगला खाली दिन {{date}} है',
    next: 'आगे बढ़ें',
  },
  verify: {
    title: 'आपका मोबाइल नंबर',
    phone: 'मोबाइल नंबर',
    phoneHint: 'हम WhatsApp पर एक-बार का कोड भेजते हैं।',
    phoneInvalid: 'यह भारतीय मोबाइल नंबर नहीं लगता।',
    send: 'कोड भेजें',
    resend: 'दोबारा भेजें',
    resendIn: 'आप {{seconds}} सेकंड बाद फिर माँग सकते हैं',
    code: 'एक-बार का कोड',
    verify: 'सत्यापित करें',
    consent: 'मुझे WhatsApp पर अपॉइंटमेंट की याद दिलाएँ',
    consentHint: 'आप इसे कभी भी बंद कर सकते हैं।',
    notice: 'हम आपकी जानकारी का क्या करते हैं',
    invalid: 'यह कोड मेल नहीं खाया। फिर कोशिश कीजिए।',
    exhausted: 'बहुत बार कोशिश हुई। नया कोड माँगिए।',
  },
  confirm: {
    title: 'अपनी बुकिंग की पुष्टि करें',
    summary: 'आपका अपॉइंटमेंट',
    total: 'कुल',
    book: 'पुष्टि करें',
    taken: 'यह समय अभी-अभी चला गया। कृपया दूसरा चुनिए।',
    policy:
      'शुरू होने से {{hours}} घंटे पहले तक आप यह बुकिंग ऑनलाइन बदल या रद्द कर सकते हैं। उसके बाद सैलून को फ़ोन कीजिए।',
  },
  detail: {
    title: 'बुकिंग {{ref}}',
    when: 'कब',
    status: 'स्थिति',
    reschedule: 'समय बदलें',
    cancel: 'यह बुकिंग रद्द करें',
    cancelTitle: 'बुकिंग {{ref}} रद्द करें?',
    cancelReason: 'कारण बताइए (ज़रूरी नहीं)',
    cancelConfirm: 'हाँ, रद्द कर दीजिए',
    cancelKeep: 'रहने दीजिए',
    locked: 'यह बुकिंग अब ऑनलाइन नहीं बदली जा सकती। कृपया सैलून को फ़ोन कीजिए।',
    pickNew: 'नया समय चुनें',
    keep: 'मौजूदा समय रहने दें',
    moved: 'आपकी बुकिंग का समय बदल दिया गया है।',
    cancelled: 'आपकी बुकिंग रद्द कर दी गई है।',
  },
  waitlist: {
    offer: 'वह समय ले लिया गया है। खाली होने पर आपको बता दें?',
    join: 'खाली होने पर बताइए',
    joined: 'जैसे ही खाली होगा, हम आपको संदेश भेज देंगे।',
    failed: 'अभी आपको जोड़ नहीं पाए। कृपया फिर कोशिश कीजिए।',
  },
  mine: {
    title: 'मेरी बुकिंग',
    none: 'आपकी कोई आने वाली बुकिंग नहीं है',
    open: 'खोलें',
  },
} as const;
